(function () {
    'use strict';

    angular.module('swif.framework')
    .service('swifRecurrenceService', swifRecurrenceService);

    /**
    * @ngdoc service
    * @name swif.framework.swifReccurrenceService
    * @requires swif.framework.dataService
    **/
    function swifRecurrenceService($q, dataService) {
        'ngInject';

        var _getDailyDates = function (recurrence, format_occurrence) {
            var date_start = recurrence.checkin !== undefined ? recurrence.checkin : recurrence.date_start;
            var date_end = recurrence.date_end ? moment(recurrence.date_end).format('YYYY-MM-DD 23:59:59') : false;

            return dataService.callKw(
                recurrence._type,
                'get_dates_from_daily_setting',
                [
                    date_start,
                    recurrence.recur_periodicity
                ],
                {
                    date_end: recurrence.recur_length_type === 'until' ? date_end : false,
                    count: recurrence.recur_length_type === 'count' ? recurrence.recur_occurrence_nb : false,
                    context: {format_occurrence: format_occurrence}
                }
            ).then(function (data) {
                recurrence.occurrences = data;
                return data;
            });
        };

        this._getWeeklyDates = function (recurrence, format_occurrence) {
            var date_start = recurrence.checkin !== undefined ? recurrence.checkin : recurrence.date_start;
            var date_end = recurrence.date_end ? moment(recurrence.date_end).format('YYYY-MM-DD 23:59:59') : false;
            var weekdays = ['monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday'];
            var val = [];
            _.forEach(weekdays, function (weekday) {
                if(recurrence['recur_week_' + weekday]) {
                    val.push(weekday);
                }
            });

            return dataService.callKw(
                recurrence._type,
                'get_dates_from_weekly_setting',
                [
                    date_start,
                    recurrence.recur_periodicity,
                    val
                ],
                {
                    date_end: recurrence.recur_length_type === 'until' ? date_end : false,
                    count: recurrence.recur_length_type === 'count' ? recurrence.recur_occurrence_nb : false,
                    context: {format_occurrence: format_occurrence}
                }
            ).then(function (data) {
                recurrence.occurrences = data;
                return data;
            });
        };

        this._getMonthlyDates = function (recurrence, format_occurrence) {
            var date_start = recurrence.checkin !== undefined ? recurrence.checkin : recurrence.date_start;
            var date_end = recurrence.date_end ? moment(recurrence.date_end).format('YYYY-MM-DD 23:59:59') : false;
            return dataService.callKw(
                recurrence._type,
                'get_dates_from_daymonthly_setting',
                [
                    date_start,
                    recurrence.recur_periodicity,
                    recurrence.recur_month_absolute
                ],
                {
                    date_end: recurrence.recur_length_type === 'until' ? date_end : false,
                    count: recurrence.recur_length_type === 'count' ? recurrence.recur_occurrence_nb : false,
                    context: {format_occurrence: format_occurrence}
                }
            ).then(function (data) {
                recurrence.occurrences = data;
                return data;
            });
        };

        this._getMonthweekdayDates = function (recurrence, format_occurrence) {
            var date_start = recurrence.checkin !== undefined ? recurrence.checkin : recurrence.date_start;
            var date_end = recurrence.date_end ? moment(recurrence.date_end).format('YYYY-MM-DD 23:59:59') : false;
            return dataService.callKw(
                recurrence._type,
                'get_dates_from_weekdaymonthly_setting',
                [
                    date_start,
                    recurrence.recur_periodicity,
                    recurrence.recur_month_relative_weight,
                    recurrence.recur_month_relative_day
                ],
                {
                    date_end: recurrence.recur_length_type === 'until' ? date_end : false,
                    count: recurrence.recur_length_type === 'count' ? recurrence.recur_occurrence_nb : false,
                    context: {format_occurrence: format_occurrence}
                }
            ).then(function (data) {
                recurrence.occurrences = data;
                return data;
            });
        };

        this._getYearlyDates = function (recurrence, format_occurrence) {
            var date_start = recurrence.checkin !== undefined ? recurrence.checkin : recurrence.date_start;
            var date_end = recurrence.date_end ? moment(recurrence.date_end).format('YYYY-MM-DD 23:59:59') : false;
            return dataService.callKw(
                recurrence._type,
                'get_dates_from_yearly_setting',
                [
                    date_start,
                    recurrence.recur_periodicity
                ],
                {
                    date_end: recurrence.recur_length_type === 'until' ? date_end : false,
                    count: recurrence.recur_length_type === 'count' ? recurrence.recur_occurrence_nb : false,
                    context: {format_occurrence: format_occurrence}
                }
            ).then(function (data) {
                recurrence.occurrences = data;
                return data;
            });
        };

        this.getDates = function (recurrence, format_occurrence) {
            var ret;

            switch(recurrence.recur_type) {
                case 'daily':
                    ret = _getDailyDates(recurrence, format_occurrence);
                    break;
                case 'weekly':
                    ret = this._getWeeklyDates(recurrence, format_occurrence);
                    break;
                case 'monthly':
                    if(recurrence.recur_month_type === 'monthday') {
                        ret = this._getMonthlyDates(recurrence, format_occurrence);
                    } else if(recurrence.recur_month_type === 'monthweekday'){
                        ret = this._getMonthweekdayDates(recurrence, format_occurrence);
                    }
                    break;
                case 'yearly':
                    ret = this._getYearlyDates(recurrence, format_occurrence);
                    break;
                default:
                    ret = $q.defer();
                    ret.resolve();
                    ret = ret.promise;
            }
            return ret;
        };
    }

})();
